import { PayrollReportStatusEnum } from "../../../dtos/payroll-report-status-enum";
import { SelectOptions } from "../../../dtos/select-options";
export const tableName = "payroll_report_table";

export type PayrollReportingTabContentProps = {
  programId?: number | null;
};

export const allOption: SelectOptions = {
  displayName: "All Active",
  stringValue: PayrollReportStatusEnum.ACTIVE.toString(),
  intValue: null,
  dateValue: null,
  decimalValue: null,
  booleanValue: null,
};

export const defaultColsAndData = { columns: [], data: [] };
